module.exports = __webpack_public_path__ + "8de6243f301dbebe2e859f351460ba75.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/referral/email.svg
// module id = 1012
// module chunks = 0